import { unsafeMapId } from "@cartographerio/atlas-map";
import { ursMap } from "../urs/helpers";

export const PlacemarkerRiverStretch = ursMap(
  unsafeMapId("placemarkerRiverStretch"),
  "River Stretch"
);
